import React, { useState } from 'react';
import TabButtons from '../../components/link/tab-buttons.jsx';
import InicioResume from './inicio-resume.js';
import AcopioResume from '../acopios/acopio-resume.js';
import { useCoopConfig } from '../../components/content/coop-config.jsx';

const InicioTabResume = () => {
    const coopConfig = useCoopConfig();
    const [dashboard, setDashboard] = useState(coopConfig.getDashboard());

    const handleDashboard = type => {
        setDashboard(type);
        coopConfig.setDashboard(type);
    };

    return (
        <>
            {coopConfig.config?.usa_acopio == 1 && (
                <div className="row mb-3">
                    <div className="col-12">
                        <TabButtons
                            btnLeftHandle={() => handleDashboard('sic')}
                            btnRightHandle={() => handleDashboard('acopio')}
                            btnDisabled={dashboard == 'sic'}
                            btnLeftLabel="Tablero SIC"
                            btnRightLabel="Tablero Acopio"
                        />
                    </div>
                </div>
            )}
            {dashboard == 'sic' ? <InicioResume /> : <AcopioResume />}
        </>
    );
};

export default InicioTabResume;